import React from "react";

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import "./ProjectsCard.scss";

export default function ProjectsCard(props) {
    return(
        <Card shadow={5} className="m-3 project-card pt-2 pb-2 col-xl-2 col-lg-3 col-md-4 col-sm-5 d-flex flex-column justify-content-between" >
            <div className="card-title text-center text-warning project-title" style={{color: '#fff', height: '250px', background:`url(${props.imageUrl}) center / cover`}}>
                <div className="pro-sub-title">{props.name}</div>
            </div>
            <div className="card-text sub-text">
                {props.description}
            </div>
                <Button href={props.link} colored>GitHub</Button>

        </Card>
    );
}